/**
 * Pure helpers for the ViewAllLinksModal.
 *
 * Extracted from ViewAllLinksModal.tsx (Sub-PR 6.4).
 */

export function getStatusColour(status: string): string {
  switch (status) {
    case 'confirmed':
      return 'bg-green-100 text-green-700 dark:bg-green-950/50 dark:text-green-400'
    case 'suspected':
      return 'bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400'
    case 'open-question':
      return 'bg-purple-100 text-purple-700 dark:bg-purple-950/50 dark:text-purple-400'
    default:
      return 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-400'
  }
}

export function formatType(type: string): string {
  return type.replaceAll('_', ' ')
}
